/**
 *  https://github.com/module-federation/universe/tree/main/packages/runtime#module-federationruntime
 *
 */

import fetchReleaseManagerManifest from './fetchManifestFromReleaseManager';
import { getMfeOverridesManifest } from './utils';

const ALLOWED_URLS = [
  /^https:\/\/localhost:\d+$/, // local
  /^https:\/\/[\w-]+-app\.local(?:-prod)?\.snap-dev\.net:\d+(\/.*)?$/, // portmapper (local + local-prod)
  /^https:\/\/[\w.-]+\.snapchat.com\/.*/,
  /^https:\/\/[\w.-]+\.sc-corp.net\/.*/, // secProxy
  /^https:\/\/[\w.-]+\.snap-dev.net\/.*/, // stage CDN
  /^https:\/\/[\w.-]+\.sc-cdn.net\/.*/, // prod CDN
];

const LOCAL_PROD_URL = 'softserve-local-prod.snap-dev.net';
const UNRELEASED_APPS = { 'campaign-lab-app': true };

/**
 *
 * @param {string} url
 */
function isValidEntry(url) {
  return ALLOWED_URLS.some((allowedUrl) => allowedUrl.test(url));
}

/**
 * Sets the remote entry URL for each remote based on the following priority (highest first):
 * 1. Test overrides from window.__TEST_MFE_OVERRIDES__
 * 2. Query params (by using ?=mfe={"remoteName":"remoteUrl"}). remoteUrl can be "local" to use portmapper or a full URL
 * 3. Manifest from index.html (injected by Release Manager) (window.moduleFederationManifest.mfes)
 * 4. ModuleFederationPlugin options (in webpack config)
 *
 * @returns { import('@module-federation/enhanced/runtime').FederationRuntimePlugin } */
function windowRuntimePlugin() {
  return {
    name: 'window-url-runtime-development-plugin',
    beforeInit(args) {
      if (window.location.hostname === LOCAL_PROD_URL) {
        args.userOptions.remotes = args.userOptions.remotes.filter((remote) => !(remote.alias in UNRELEASED_APPS));
      }

      return args;
    },
    async beforeRequest(args) {
      const overrideManifest = getMfeOverridesManifest(
        new URLSearchParams(window.location.search).get('mfe') ?? undefined,
        window.__TEST_MFE_OVERRIDES__,
      );

      // if using local mode - get the latest manifest from Release Manager
      if (__LOCAL__) {
        const manifest = await fetchReleaseManagerManifest();
        window.moduleFederationManifest = { mfes: manifest };
      }

      args.options.remotes.forEach((remote) => {
        // Priority: test override, query, RM manifest (local only), then window
        const newEntry = overrideManifest[remote.alias] ?? window.moduleFederationManifest?.mfes?.[remote.alias]?.url;

        if (newEntry && isValidEntry(newEntry)) {
          remote.entry = newEntry;
        }
      });

      return args;
    },
  };
}

export default windowRuntimePlugin;
